<template>
    <div>
        <div class="total-text">清算统计：{{ total }}</div>
        <div v-for="item in value" :key="item.id" class="container">
            <div class="title">{{ item.title }}</div>
            <div class="row-class">
                <Row
                    :gutter="20"
                    v-for="(row, rowIndex) in item.list"
                    :key="`${item.id}-${rowIndex}`"
                >
                    <Col
                        :span="colIndex === 4 ? 4 : 5"
                        v-for="(col, colIndex) in row"
                        :key="`${item.id}-${rowIndex}-${colIndex}`"
                    >
                        {{ col.text }} : {{ col.val }}
                        <!-- <span class="res-amount-text" v-if="col.resAmountText">
                            {{ col.resAmountText }}
                        </span> -->
                    </Col>
                </Row>
            </div>
        </div>
        <Form :label-width="50" style="margin-top: 10px">
            <FormItem label="备注">
                <Input
                    type="textarea"
                    :viewonly="this.history"
                    v-model="info.remark"
                />
            </FormItem>
        </Form>
        <div class="fixBtn" v-if="change">
            <Col :span="12">
                <Button
                    type="primary"
                    style="float: right; margin-right: 10px"
                    :loading="loading"
                    @click="onConfirmBtnClick"
                    >账单修正</Button
                >
            </Col>
            <Col :span="12">
                <Button
                    :disabled="disabled"
                    @click="onCancelBtnClick"
                    style="margin-left: 10px"
                    >取消</Button
                >
            </Col>
        </div>
    </div>
</template>

<script>
import { chargeDetailsTotal } from '@/views/common/u-contract'
export default {
    name: 'ChargeDetails',
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        history: {
            type: Boolean,
            default: false,
        },
        remark: {
            type: String,
            default: '',
        },
        change: {
            type: Boolean,
            default: false,
        },
    },
    inject: {
        $modal: {
            default: null,
        },
    },
    data() {
        return {
            info: {
                remark: this.remark,
            },
            loading: false,
            disabled: false,
            total: 0,
        }
    },
    mounted() {
        var $info = this.$refs.info
        let btns = []
        // 按钮配置
        if (!this.change) {
            if (this.history) {
                btns = [{ type: 'default', text: '关闭', name: 'cancel' }]
            } else {
                btns = [{ type: 'default', text: '取消', name: 'cancel' }]
                btns.unshift({
                    type: 'primary',
                    name: 'confirm',
                    text: '确定退租',
                })
            }
        }

        this.$modal.updateBtns(btns)
    },
    watch: {
        'info.remark'(val) {
            this.$emit('update:remark', val)
        },
        value: {
            handler() {
                this.total = chargeDetailsTotal(this.value)
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        onConfirmBtnClick() {
            this.$emit('popChange')
        },
        onCancelBtnClick() {
            this.$modal.close()
        },
    },
}
</script>

<style lang="less" scoped>
.container + .container {
    margin-top: 20px;
}
.title {
    background: #f8f8f9;
    width: 100%;
    line-height: 40px;
    padding-left: 10px;
}
.row-class {
    line-height: 40px;
    margin-left: 15px;
}
.fixBtn {
    width: calc(100% - 20px);
    position: absolute;
    bottom: 0;
    background: rgb(255, 255, 255);
    margin-bottom: 20px;
}
.res-amount-text {
    color: red;
    position: absolute;
    top: 23px;
    left: 10px;
    height: 20px;
    line-height: 20px;
}
.total-text {
    font-size: 16px;
    padding: 0px 0px 5px 0px;
}
</style>
